import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FiltersService} from 'src/app/core/services/filters.service';
import { FilterRequests } from 'src/app/core/services/filter-requests.service';
import {Subscription} from "rxjs";
import { ContractModel } from 'src/app/global/contract-filter-model';

@Component({
    selector: 'filter-name-panel',
    templateUrl: './filter-name-panel.component.html',
    styleUrls: ['./filter-name-panel.component.scss'],
    standalone: false
})


export class FilterNamePanelComponent implements OnInit {
  @Input() divDataView: string = "";
  @Input() inputModel: string | undefined;
  @Output() hideFilterNamePanel = new EventEmitter<string>();
  @Output() inputModelChange = new EventEmitter<string>();


  constructor(
      private filtersService: FiltersService,
      private filterRequests : FilterRequests,
  ) { }

  // Filter selections
  name = '';
  filterCount = 0;
  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;

  // Name box
  textCount: number | undefined;

  customDateRange : string = '';

  ngOnInit(): void {
    this.filtersSubscription = this.filtersService.selectedFiltersObservable.subscribe(f => {this.filters = f;})
    this.filtersSubscription = this.filtersService.customDateRange.subscribe(f => {this.customDateRange = `${f.startDate.formatted}:${f.endDate.formatted}`;})

    if (this.inputModel != undefined) {
      this.textCount = this.inputModel.length;
    } else {
      this.textCount = 0;
    }
  }

  async clickSaveButton() {
    const name = this.inputModel!;

    // check for blank
    if (this.inputModel === undefined) {
      window.alert("Please enter a name for your set of filters.");
      return false;

    } else {
      // do the save
      return this.filterRequests.addSavedFilterSetContractModel(name, this.filters , this.divDataView, this.customDateRange).then(response => {
        const {data} = response;
        if (data != undefined) {

          // hide the name popup
          this.hideFilterNamePanel.emit();
          window.alert('Saved set of filters as: "' + name + '".');
          return data;
        }

      }).catch(async error => {
        // an error here is most likely the name exists already
        window.alert("That name is already in use. Please try another.");
      });
    }

  }

  clickCloseLink() {
    this.hideFilterNamePanel.emit();
  }

  keyEvent(event: { keyCode: number; preventDefault: () => void; })
  {
    if(event.keyCode === 13)
    {
      event.preventDefault();
      this.clickSaveButton();
    }

    if(event.keyCode === 27)
    {
      event.preventDefault();
      this.clickCloseLink();
    }
  }

  textChange(){
    this.inputModelChange.emit(this.inputModel);
    this.textCount = this.inputModel!.length;
  }

}
